// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import layout from './components/layout'
import ElementUI from 'element-ui'
import iCard from '@/components/i-card'
import iUpload from '@/components/i-upload'
import http from '@/api/http'
import store from "@/config/store"
import leftMenuConfig from '@/config/left_menu'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/style/common.less'
import './assets/style/animate.css'
import './assets/style/icon-font/iconfont.css'
//高德地图

import AmapVue from '@amap/amap-vue';
AmapVue.config.key = '980fa9eef13ba5b4f6ecbe8e2757cde5';
AmapVue.config.plugins = [
  'AMap.PlaceSearch', 'AMap.AutoComplete'
];
Vue.config.productionTip = false;
Vue.prototype.$http = http;
Vue.component('layout', layout);
Vue.component('i-card', iCard);
Vue.component('i-upload', iUpload);
Vue.use(AmapVue);
Vue.use(ElementUI);
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>',
  methods: {
    //设置标题
    setTitle: function () {
      let meta = this.$route.meta;
      document.title = meta.title;
      window.scrollTo(0,0)
    },
    //当前菜单高亮显示
    menuHighLight: function () {
      let leftMenu = this.$store.state.leftMenu;
      if (leftMenu.length <= 0) {
        leftMenu = leftMenuConfig;
      }
      let group = this.$route.meta.group;
      for (let menu in leftMenu) {
        leftMenu[menu].selected = leftMenu[menu].group === group;
        for (let subItem in leftMenu[menu].children) {
          leftMenu[menu].children[subItem].selected = leftMenu[menu].children[subItem].group === group;
        }
      }
      this.$store.commit('leftMenu', leftMenu);
    },
    //检查登录
    checkLogin: function () {
      let user = JSON.parse(localStorage.getItem('user'));
      let currRoute = this.$route.path;
      if (!user && currRoute !== '/login') {
        this.$router.push({name: 'login', query: {url: currRoute}});
      }
      if (user && currRoute === '/login') {
        this.$router.replace({name:'index'});
      }
    },
    //获取我的权限
    getPrivilegeList:function (){
      let user = JSON.parse(localStorage.getItem('user'));
      if(user){
        this.$http.request('myPrivilegeList').then(res=>{
          this.$store.commit('privilegeIds', res.data);
        });
      }

    }
  },
  created: function () {
    this.setTitle();
    this.menuHighLight();
    this.checkLogin();
    this.getPrivilegeList();
  },
  watch: {
    $route: function () {
      this.setTitle();
      this.menuHighLight();
      this.checkLogin();
      this.getPrivilegeList();
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js